const splitValue = (value) => {
    if (!value)
        return "";
    return value
        .split(/\r+|\n/)
        .map((s) => s.trim())
        .filter((s) => s !== "");
};
export default splitValue;
